module.exports = __webpack_public_path__ + "static/media/receivable_schedules_await.aa4e4148.png";